import React, {useContext, useEffect, useRef, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import Options from '@components/Options';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import WarningIcon from '@assets/icons/warningIcon';
import NotDescribed from '@assets/icons/notDescribed';
import { getOEMName } from 'utils/editor';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import FullPreview from '@routes/private/Studio/components/FullPreview';
import OptionIcon from '@assets/icons/optionIcon';
import { ITemplate } from '@state/templates/types';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';
import { IUserAccessBrand } from '@state/userAccess/types';
import Menu from '../Menu';
import { ItemName } from '@routes/private/Editor/Editor/AppBar/MenuOptions/GalleryExport/AssetsExplorer/styles';

const ItemUserProfile:React.FC<IProps> = ({item, idx, onActionsTemplate, selected, setOpen, handleSelectedIndexes, handleMenu}) => {
  const userAccessContext = useContext(UserAccessContext)
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const textName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const textTags = useRef() as React.MutableRefObject<HTMLInputElement>;
  const textClientIds = useRef() as React.MutableRefObject<HTMLInputElement>;
  const textState = useRef() as React.MutableRefObject<HTMLInputElement>;  
  const [tootltipName, showTooltipname]= useState(false);
  const [tootltipTags, showTooltiptag]= useState(false);
  const [tootltipclientIds, showTooltipclientIds]= useState(false);
  const [tootltipState, showTooltipstate]= useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [viewPreview, setViewPreview] = useState(false);
  const [tootltipMore, showTooltipMore]= useState(false);
  const [allTootltip, setAllTootltip]= useState(false);
  const maxOemList=10;

  const handleActionsTemplate = (action: string, item: ITemplate[], idx: number) => {
    if (action=="PREVIEW")
      setViewPreview(true)
    else  
      onActionsTemplate(action, item, idx);
  }

  const tooltipValidate = (colName: string) => {       
    if(colName==='name'){
    const compare = textName.current.scrollWidth > textName.current.clientWidth;
    if(compare)showTooltipname(true);
    }
    else if (colName==='state')
    {
      showTooltipstate(true)
    }
    else if (colName==='clientIds'){
      const compare = textClientIds.current.scrollWidth > textClientIds.current.clientWidth;
      if(compare)showTooltipclientIds(true); 
    }
    else{
      const compare = textTags.current.scrollWidth > textTags.current.clientWidth;
      if(compare)showTooltiptag(true);
    }
    setAllTootltip(false);
  };

  const handleOpenOptions = (e: any) => {
    e.stopPropagation();    
    handleMenu(item,{x:e.clientX, y:e.clientY});
 }

  
  const handleContextMenu = (e: any) => {
    if (selected && setOpen) {
      e.preventDefault();
      setOpen(true);
    }
  }

  const getBrandsText = (brands: IUserAccessBrand[])=>{
    var brandNames = brands.map((brand:IUserAccessBrand)=>{
        return brand.name
    })
    return brandNames.join(', ')
  }


  const getBrandOemList=(all:boolean)=>{

    let oemlist = ''
    if (item.brands)
    {
      let brandList = !all && item.brands.length> maxOemList ? item.brands.slice(0,maxOemList):item.brands
      brandList.map((brand:IUserAccessBrand)=>{
        oemlist+= (oemlist!=''?', ':'') + brand.name
      })      

      if (!all && item.brands.length> maxOemList)
        oemlist+= ' +' + (item.brands.length - maxOemList)
    }
    return oemlist;    

  }

  const getClientIdsList=(all:boolean)=>{

    let clientIdList = ''
    if (item.clientIds)
    {
      let clientIds = !all && item.clientIds.length> maxOemList ? item.clientIds.slice(0,maxOemList):item.clientIds
      clientIds.map((clientId:string)=>{
        clientIdList+= (clientIdList!=''?', ':'') + clientId
      })      

      if (!all && item.clientIds.length> maxOemList)
        clientIdList+= ' +' + (item.clientIds.length - maxOemList)
    }
    return clientIdList;    

  }
  
  return (
    <S.Root id={`item-row-${item?.id}`}>
      <S.Row
        border={selected ? true : false}        
        onContextMenu={handleContextMenu}
      >
        <S.ColEmail ref={textName}>
            <S.Label>Email:</S.Label>
            {item.user.email}
        </S.ColEmail>        
        <S.ColTags ref={textClientIds} onMouseOver={(e)=>tooltipValidate('clientIds')} onMouseOut={()=>showTooltipclientIds(false)}>
            <S.Text>
              <S.Label>Client Ids:</S.Label>
              { item.clientIds?.join(', ') ?? [] }
            </S.Text>
        </S.ColTags>  
        <S.Tooltip style={{display: tootltipclientIds || tootltipMore?'block':'none', left: '25%'}}
          onMouseOver={()=>showTooltipMore(true)} onMouseOut={()=>{showTooltipMore(false)}}
        >
          <S.TooltipContainer>
          {
            getClientIdsList(allTootltip)            
          }
          </S.TooltipContainer>          
          {
            !allTootltip && item.clientIds && item.clientIds?.length> maxOemList &&
            <S.TooltipSeeAll onClick={()=> setAllTootltip(!allTootltip)}>
              {
                allTootltip?`See less`:`See more`
              }
            </S.TooltipSeeAll>
            
          }
        </S.Tooltip>
        <S.ColTags ref={textTags} onMouseOver={(e)=>tooltipValidate('tags')} onMouseOut={()=>showTooltiptag(false)}>
            <S.Text>
              <S.Label>Brands:</S.Label>
              { getBrandsText(item.brands ?? []) }
            </S.Text>
        </S.ColTags>  
        <S.Tooltip style={{display: tootltipTags || tootltipMore?'block':'none', left: '50%'}}
          onMouseOver={()=>showTooltipMore(true)} onMouseOut={()=>{showTooltipMore(false)}}
        >
          <S.TooltipContainer>
          {
            getBrandOemList(allTootltip)            
          }
          </S.TooltipContainer>          
          {
            !allTootltip && item.brands && item.brands?.length> maxOemList &&
            <S.TooltipSeeAll onClick={()=> setAllTootltip(!allTootltip)}>
              {
                allTootltip?`See less`:`See more`
              }
            </S.TooltipSeeAll>
            
          }
        </S.Tooltip>                 
        <S.ColName>
            <S.Label>Name:</S.Label>
            <S.Text>{ item.user.name}
            </S.Text>
        </S.ColName>
        <S.ColEdited>
            <S.Label>Last active:</S.Label>
            <S.Text>{item.lastActive? new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.lastActive??'')):``}
            </S.Text>            
        </S.ColEdited>        
        <S.ColOptions>
            <S.IconContainer onClick={handleOpenOptions}>
              <OptionIcon/>
            </S.IconContainer>
        </S.ColOptions>
      </S.Row>  
    </S.Root >
  );
}

export default ItemUserProfile;